import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHierarchyLine = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 9 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.676025 0V32.1647H8.67603",
		stroke: "#BFBFBF",
		strokeWidth: "1px",
		fill: "none"
	})]
});
const ForwardRef = forwardRef(SvgHierarchyLine);
export { ForwardRef as ReactComponent };
